import { useState } from 'react'
import { useSelector } from 'react-redux'
import { downloadFollowUp } from 'services/results/follow-up'
import { canViewFollowUpComparison } from 'services/results/follow-up-access'
import { StrokedButton } from 'views/components/UI/Buttons'
import { useNotification } from 'lib/context/notification.context'

export default function ProcessReportsDownload({ processId, userId }: { processId: number; userId: number }) {
  const role = useSelector((state: any) => state.auth.role)
  const [busy, setBusy] = useState(false)
  const { getError } = useNotification()
  if (!canViewFollowUpComparison(role) || !processId || !userId) return null
  const download = async () => {
    if (busy) return
    setBusy(true)
    try {
      await downloadFollowUp(
        processId,
        `participant/${userId}/reports.zip`,
        `Informes_Proceso_${processId}_Evaluado_${userId}.zip`
      )
    } catch {
      getError(
        'No se pudieron descargar los informes. Comprueba que haya mediciones completadas y que conserves acceso al proceso.'
      )
    } finally {
      setBusy(false)
    }
  }
  return (
    <span title="ZIP con informes completados y comparativos disponibles de este evaluado en el proceso">
      <StrokedButton disabled={busy} aria-busy={busy} onClick={download}>
        {busy ? 'Preparando informes…' : 'Descargar los Informes'}
      </StrokedButton>
    </span>
  )
}
